import { render, staticRenderFns } from "./PartnerNotificationView.vue?vue&type=template&id=f815b8a4&scoped=true"
import script from "./PartnerNotificationView.vue?vue&type=script&lang=js"
export * from "./PartnerNotificationView.vue?vue&type=script&lang=js"
import style0 from "./PartnerNotificationView.vue?vue&type=style&index=0&id=f815b8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f815b8a4",
  null
  
)

export default component.exports